import React, { ReactNode } from 'react';
import {
  CustomDivider,
  HeaderText,
  StyledCard,
  StyledFlex,
} from './CustomCard.styles';
import { Flex } from '@amzn/storm-ui';

interface CardProps {
  id?: string;
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}

export const CustomCard: React.FC<CardProps> = ({
  id,
  title,
  children,
  actions,
}) => {
  return (
    <StyledCard id={id}>
      <StyledFlex>
        <HeaderText>{title}</HeaderText>
        {actions && <Flex>{actions}</Flex>}
      </StyledFlex>
      <CustomDivider />
      {children}
    </StyledCard>
  );
};
